import * as types from './index';

export const fetchLocalityAction = (locality) => {
  return {
    type: types.LOCALITY_FETCH,
    locality
  }
};

export const fetchDistrictAction = (payload) => {
  return {
    type: types.DISTRICT_FETCH,
    payload
  }
};